export enum subscriptionPaymentFlowScreenView {
  selectProgram = 0,
  checkout = 1,
  success = 2,
  selectProgramVerify = 3,
  familyPlanRequest = 99,
}
